import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-constants';

export const Route = createFileRoute('/_staff/accesses/_layout/list/')({
  validateSearch: zodValidator(SearchSchema),
});
